<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.applicant}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-radio-group :label="labels.appIntStat" v-model="cargoForm.applicant.appIntStat" row :disabled="lockAppIntStat" :error-messages="errors.collect('appIntStat')" data-vv-name="appIntStat" :data-vv-as="labels.appIntStat" v-validate="'required'" @change="doAppIntStat">
                <v-radio v-for="status in appIntStatList" :key="status.value" :label="status.label" :value="status.value" :disabled="lockAppIntStat"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex lg6 xs12>
            </v-flex>
            <v-flex lg6 xs12 v-if="cargoForm.applicant.appIntStat === 'I'">
              <v-text-field key="appName" v-model="cargoForm.applicant.appName" :label="labels.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="labels.appName" v-validate="'required|name|max:50'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="cargoForm.applicant.appIntStat === 'I'">
              <v-text-field v-uppercase key="appNricPassport" v-model="cargoForm.applicant.appNricPassport" :label="labels.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="labels.appNricPassport" v-validate="'alpha_num|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="cargoForm.applicant.appIntStat === 'I'">
              <v-text-field key="appOccupation" v-model="cargoForm.applicant.appOccupation" :label="labels.busOccp" :error-messages="errors.collect('appOccupation')" data-vv-name="appOccupation" :data-vv-as="labels.busOccp" v-validate="'entry|max:33'"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cargoForm.applicant.appIntStat === 'E'">
              <v-text-field key="coyName" v-model="cargoForm.applicant.coyName" :label="labels.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="labels.coyName" v-validate="'required|name|max:60'"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cargoForm.applicant.appIntStat === 'E'">
              <v-text-field key="coyName2" v-model="cargoForm.applicant.coyName2" :label="labels.coyName2" :error-messages="errors.collect('coyName2')" data-vv-name="coyName2" :data-vv-as="labels.coyName2" v-validate="'name|max:60'"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cargoForm.applicant.appIntStat === 'E'">
              <v-text-field key="finInstDesc" v-model="cargoForm.finInstDesc" :label="labels.finInstDesc" :error-messages="errors.collect('finInstDesc')" data-vv-name="finInstDesc" :data-vv-as="labels.finInstDesc" v-validate="'name|max:60'"></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="cargoForm.applicant.appIntStat === 'E'">
              <v-text-field key="finInstDesc2" v-model="cargoForm.finInstDesc2" :label="labels.finInstDesc2" :error-messages="errors.collect('finInstDesc2')" data-vv-name="finInstDesc2" :data-vv-as="labels.finInstDesc2" v-validate="'name|max:60'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="cargoForm.applicant.appIntStat === 'E'">
              <v-text-field key="coyRocUen" v-model="cargoForm.applicant.coyRocUen" :label="labels.coyRocUen" :error-messages="errors.collect('coyRocUen')" data-vv-name="coyRocUen" :data-vv-as="labels.coyRocUen" v-validate="'entry|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="cargoForm.applicant.appIntStat === 'E'">
              <v-text-field key="coyNature" v-model="cargoForm.applicant.coyNature" :label="labels.busOccp" :error-messages="errors.collect('coyNature')" data-vv-name="coyNature" :data-vv-as="labels.busOccp" v-validate="'entry|max:33'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.finInst" v-model="cargoForm.finInst" :label="labels.finInst" item-text="label" item-value="value" data-vv-name="finInst" :data-vv-as="labels.finInst" :error-messages="errors.collect('finInst')" :loading="finInstLoading" clearable></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.appAddress}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field v-model="cargoForm.applicant.appAdd3" :label="labels.appAdd3" :error-messages="errors.collect('appAdd3')" data-vv-name="appAdd3" :data-vv-as="labels.appAdd3" prefix="#" v-validate="'entry|max:30'" :disabled="cargoForm.applicant.appAdd"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="cargoForm.applicant.appPostalCode" :label="labels.appPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('appPostalCode')" data-vv-name="appPostalCode" :disabled="cargoForm.applicant.appAdd" :data-vv-as="labels.appPostalCode" :loading="appPostalCodeLoading" @change="doAppAddress"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="cargoForm.applicant.appAdd1" :label="labels.appAdd1" :error-messages="errors.collect('appAdd1')" data-vv-name="appAdd1" :data-vv-as="labels.appAdd1" v-validate="'entry|max:30'" :disabled="cargoForm.applicant.appAdd"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="cargoForm.applicant.appAdd2" :label="labels.appAdd2" :error-messages="errors.collect('appAdd2')" data-vv-name="appAdd2" :data-vv-as="labels.appAdd2" v-validate="'entry|max:255'" :disabled="cargoForm.applicant.appAdd"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="cargoForm.applicant.appAdd4" :label="labels.appAdd4" :error-messages="errors.collect('appAdd4')" data-vv-name="appAdd4" :data-vv-as="labels.appAdd4" v-validate="'entry|max:255'" :disabled="cargoForm.applicant.appAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.appState" v-model="cargoForm.applicant.appState" :error-messages="errors.collect('appState')" data-vv-name="appState" :data-vv-as="labels.appState" v-validate="'max:30|entry'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.countries" v-model="cargoForm.applicant.appCountry" :label="labels.appCountry" item-text="label" item-value="value" data-vv-name="appCountry" :data-vv-as="labels.appCountry" :error-messages="errors.collect('appCountry')" clearable :loading="countryLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.mailAddress}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-checkbox v-model="cargoForm.applicant.mailAdd" :label="labels.mailAdd" data-vv-name="mailAdd" :data-vv-as="labels.mailAdd" :error-messages="errors.collect('mailAdd')" @change="doMailAdd" hide-details></v-checkbox>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.mailAdd3" v-model="cargoForm.applicant.mailAdd3" :error-messages="errors.collect('mailAdd3')" data-vv-name="mailAdd3" :data-vv-as="labels.mailAdd3" v-validate="'max:30|entry'" :disabled="cargoForm.applicant.mailAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="cargoForm.applicant.mailPostalCode" :label="labels.mailPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('mailPostalCode')" data-vv-name="mailPostalCode" :disabled="cargoForm.applicant.mailAdd" :data-vv-as="labels.mailPostalCode" :loading="appPostalCodeLoading" @change="doAppAddress"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.mailAdd1" v-model="cargoForm.applicant.mailAdd1" :error-messages="errors.collect('mailAdd1')" data-vv-name="mailAdd1" :data-vv-as="labels.mailAdd1" v-validate="'max:30|entry'" :disabled="cargoForm.applicant.mailAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.mailAdd2" v-model="cargoForm.applicant.mailAdd2" :error-messages="errors.collect('mailAdd2')" data-vv-name="mailAdd2" :data-vv-as="labels.mailAdd2" v-validate="'max:255|entry'" :disabled="cargoForm.applicant.mailAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.mailAdd4" v-model="cargoForm.applicant.mailAdd4" :error-messages="errors.collect('mailAdd4')" data-vv-name="mailAdd4" :data-vv-as="labels.mailAdd4" v-validate="'max:255|entry'" :disabled="cargoForm.applicant.mailAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.mailState" v-model="cargoForm.applicant.mailState" :error-messages="errors.collect('mailState')" data-vv-name="mailState" :data-vv-as="labels.mailState" v-validate="'max:30|entry'" :disabled="cargoForm.applicant.mailAdd"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.countries" v-model="cargoForm.applicant.mailCountry" :label="labels.mailCountry" item-text="label" item-value="value" data-vv-name="mailCountry" :data-vv-as="labels.mailCountry" :error-messages="errors.collect('mailCountry')" :disabled="cargoForm.applicant.mailAdd" clearable :loading="countryLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.appContact}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg12 xs12>
              <v-text-field :label="labels.appEmail" v-model="cargoForm.applicant.appEmail" :error-messages="errors.collect('appEmail')" data-vv-name="appEmail" :data-vv-as="labels.appEmail" v-validate="'email'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.appMobileNo" v-model="cargoForm.applicant.appMobileNo" type="tel" :error-messages="errors.collect('appMobileNo')" data-vv-name="appMobileNo" :data-vv-as="labels.appMobileNo" v-validate="{ required:cargoForm.applicant.appIntStat === 'I', numeric:true, max:8 }"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.appTelNo1" v-model="cargoForm.applicant.appTelNo1" type="tel" :error-messages="errors.collect('appTelNo1')" data-vv-name="appTelNo1" :data-vv-as="labels.appTelNo1" v-validate="'numeric|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.appTelNo2" v-model="cargoForm.applicant.appTelNo2" type="tel" :error-messages="errors.collect('appTelNo2')" data-vv-name="appTelNo2" :data-vv-as="labels.appTelNo2" v-validate="'numeric|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.appFaxNo" v-model="cargoForm.applicant.appFaxNo" type="tel" :error-messages="errors.collect('appFaxNo')" data-vv-name="appFaxNo" :data-vv-as="labels.appFaxNo" v-validate="'numeric|max:20'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading" v-if="showGetPremium">
        Get Premium
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn color="primary" type="submit" :loading="quotation.saving" @click.prevent="doSendForRef" v-else>
        Send for Review
        <v-icon right dark>mdi-account-check</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LEAVEQUOTE, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_LOADING, QUOTE_CARGO_PARAM, QUOTE_CARGO_INSURED, QUOTE_CARGO_PARAM_INSURED } from '@/store/types'
import { applicantStatus } from '@/const/underwriting'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { expandURI } from '@/utils/ajax'
import { mapGetters } from 'vuex'
import { generalCargoForm } from '@/store/modules/agency/actions/quote'

export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appIntStat: 'Applicant Status',
        appName: 'Name as in NRIC/Passport*',
        coyName: 'Name of Company*',
        coyName2: '',
        finInstDesc: '',
        finInstDesc2: '',
        appNricPassport: 'NRIC/Passport',
        coyRocUen: 'ROC/UEN',
        busOccp: 'Business/Occupation',
        finInst: 'Bank Interest',
        appAddress: 'Applicant Address',
        appAdd1: 'Block/House No.',
        appAdd2: 'Street Name',
        appAdd3: 'Unit No.',
        appAdd4: 'Building Name',
        appPostalCode: 'Postal Code',
        appState: 'State',
        appCountry: 'Country',
        mailAdd: 'Same as Applicant Address',
        mailAddress: 'Mailing Address',
        mailPostalCode: 'Postal Code',
        mailAdd1: 'Block No.',
        mailAdd2: 'Street Name',
        mailAdd3: 'Unit No.',
        mailAdd4: 'Building Name',
        mailState: 'State',
        mailCountry: 'Country',
        appContact: 'Contacts',
        appEmail: 'Email',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No.',
        appFaxNo: 'Fax No.'
      },
      cargoForm: {
        applicant: {
          appIntStat: undefined,
          appSalutation: undefined,
          appName: undefined,
          appNricPassport: undefined,
          appOccupation: undefined,
          appEmail: undefined,
          appMobileNo: undefined,
          appTelNo1: undefined,
          appTelNo2: undefined,
          appFaxNo: undefined,
          appAdd1: undefined,
          appAdd2: undefined,
          appAdd3: undefined,
          appAdd4: undefined,
          appState: undefined,
          appCountry: undefined,
          appPostalCode: undefined,
          mailAdd: undefined,
          mailPostalCode: undefined,
          mailAdd1: undefined,
          mailAdd2: undefined,
          mailAdd3: undefined,
          mailAdd4: undefined,
          mailState: undefined,
          mailCountry: undefined,
          coyName: undefined,
          coyName2: undefined,
          coyRocUen: undefined,
          coyNature: undefined
        },
        finInst: undefined,
        finInstDesc: undefined,
        finInstDesc2: undefined
      },
      finInstLoading: false,
      countryLoading: false,
      appPostalCodeLoading: false,
      mailPostalCodeLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    quoteParam() {
      return this.$store.state.agency.quotation.cargoParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    appIntStatList() {
      // Convert object to arr
      let result = []
      Object.keys(applicantStatus).forEach(function (key) {
        const status = applicantStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    lockAppIntStat() {
      // Check for permAppStat from tariff
      let result = false
      if (this.quoteParam.tariff && this.quoteParam.tariff.length > 0 && this.globalForm.tariff) {
        const filter = this.quoteParam.tariff.filter(tariff => tariff.value === this.globalForm.tariff)
        if (filter && filter.length > 0) {
          const tariff = filter[0]
          if (tariff.permAppStat !== null) {
            result = !tariff.permAppStat
          }
        }
      }
      return result
    },
    proceedLoading() {
      if (this.finInstLoading || this.countryLoading || this.appPostalCodeLoading || this.mailPostalCodeLoading) {
        return true
      } else {
        return false
      }
    },
    showGetPremium() {
      // Only allow if user has permit acccess
      if (this.checkAccess(['cargoQuotePremRate'])) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async doInit() {
      // Default value from vuex store 1st

      // Applicant
      const { applicant } = this.globalCommonForm
      this.cargoForm.applicant.appIntStat = applicant.appIntStat
      this.cargoForm.applicant.appName = applicant.appName
      this.cargoForm.applicant.appNricPassport = applicant.appNricPassport
      this.cargoForm.applicant.appOccupation = applicant.appOccupation
      this.cargoForm.applicant.appEmail = applicant.appEmail
      this.cargoForm.applicant.appMobileNo = applicant.appMobileNo
      this.cargoForm.applicant.appTelNo1 = applicant.appTelNo1
      this.cargoForm.applicant.appTelNo2 = applicant.appTelNo2
      this.cargoForm.applicant.appFaxNo = applicant.appFaxNo
      this.cargoForm.applicant.appPostalCode = applicant.appPostalCode
      this.cargoForm.applicant.appAdd1 = applicant.appAdd1
      this.cargoForm.applicant.appAdd2 = applicant.appAdd2
      this.cargoForm.applicant.appAdd3 = applicant.appAdd3
      this.cargoForm.applicant.appAdd4 = applicant.appAdd4
      this.cargoForm.applicant.appState = applicant.appState
      this.cargoForm.applicant.appCountry = applicant.appCountry
      this.cargoForm.applicant.mailAdd = applicant.mailAdd
      this.cargoForm.applicant.mailPostalCode = applicant.mailPostalCode
      this.cargoForm.applicant.mailAdd1 = applicant.mailAdd1
      this.cargoForm.applicant.mailAdd2 = applicant.mailAdd2
      this.cargoForm.applicant.mailAdd3 = applicant.mailAdd3
      this.cargoForm.applicant.mailAdd4 = applicant.mailAdd4
      this.cargoForm.applicant.mailState = applicant.mailState
      this.cargoForm.applicant.mailCountry = applicant.mailCountry
      this.cargoForm.applicant.coyName = applicant.coyName
      this.cargoForm.applicant.coyName2 = applicant.coyName2
      this.cargoForm.applicant.coyRocUen = applicant.coyRocUen
      this.cargoForm.applicant.coyNature = applicant.coyNature

      this.cargoForm.finInst = this.globalCommonForm.finInst
      this.cargoForm.finInstDesc = this.globalForm.finInstDesc
      this.cargoForm.finInstDesc2 = this.globalForm.finInstDesc2
      if (this.lockAppIntStat) {
        // When locked, default to Entity - Cargo only
        this.cargoForm.applicant.appIntStat = 'E'
      } else {
        if (!this.cargoForm.applicant.appIntStat && this.appIntStatList && this.appIntStatList.length > 0) {
          // default to Entity
          this.cargoForm.applicant.appIntStat = 'E'
        }
      }

      if (!this.quoteParam.insuredLoaded) {
        this.getFinInst()
        this.getCountry()
        this.$store.commit(QUOTE_CARGO_PARAM_INSURED, true)
      }
    },
    async doAppAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.appPostalCodeLoading = true
          const expand = {
            postCode: this.cargoForm.applicant.appPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.cargoForm.applicant.appAdd1 = data.add1
            this.cargoForm.applicant.appAdd2 = data.add2
            this.cargoForm.applicant.appAdd4 = data.add4
          }
          this.appPostalCodeLoading = false
        } catch (err) {
          this.appPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doMailAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.mailPostalCodeLoading = true
          const expand = {
            postCode: this.cargoForm.applicant.mailPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.cargoForm.applicant.mailAdd1 = data.add1
            this.cargoForm.applicant.mailAdd2 = data.add2
            this.cargoForm.applicant.mailAdd4 = data.add4
          }
          this.mailPostalCodeLoading = false
        } catch (err) {
          this.mailPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doMailAdd() {
      this.cargoForm.applicant.mailAdd1 = this.cargoForm.applicant.appAdd1
      this.cargoForm.applicant.mailAdd2 = this.cargoForm.applicant.appAdd2
      this.cargoForm.applicant.mailAdd3 = this.cargoForm.applicant.appAdd3
      this.cargoForm.applicant.mailAdd4 = this.cargoForm.applicant.appAdd4
      this.cargoForm.applicant.mailPostalCode = this.cargoForm.applicant.appPostalCode
      this.cargoForm.applicant.mailState = this.cargoForm.applicant.appState
      this.cargoForm.applicant.mailCountry = this.cargoForm.applicant.appCountry
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    async getFinInst() {
      const apiURI = this.$store.state.agency.quotation.menu.finInst
      if (apiURI) {
        try {
          this.finInstLoading = true
          const tempAcceptDate = this.formatDate(this.globalCommonForm.acceptDate)
          const expand = {
            effDate: tempAcceptDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              finInst: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.finInstLoading = false

            if (this.cargoForm.finInst && this.quoteParam.finInst && this.quoteParam.finInst.length > 0) {
              // Check if the current finInst value is still valid
              let finInstIsValid = false
              for (var i = 0; i < this.quoteParam.finInst.length; i++) {
                const finInst = this.quoteParam.finInst[i]
                if (finInst.value === this.cargoForm.finInst) {
                  finInstIsValid = true
                  break
                }
              }
              // Invalid Survey Agent (reset to undefined)
              if (!finInstIsValid) {
                this.cargoForm.finInst = undefined
              }
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.finInstLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getCountry() {
      const apiURI = this.$store.state.agency.quotation.menu.country
      if (apiURI) {
        this.countryLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              countries: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.countryLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.countryLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doAppIntStat() {
      // Reset some values
      if (this.cargoForm.applicant.appIntStat && this.cargoForm.applicant.appIntStat === 'E') {
        this.cargoForm.applicant.appName = undefined
        this.cargoForm.applicant.appNricPassport = undefined
        this.cargoForm.applicant.appOccupation = undefined
      } else if (this.cargoForm.applicant.appIntStat && this.cargoForm.applicant.appIntStat === 'I') {
        this.cargoForm.applicant.coyName = undefined
        this.cargoForm.applicant.coyName2 = undefined
        this.cargoForm.applicant.coyRocUen = undefined
        this.cargoForm.applicant.coyNature = undefined
        this.cargoForm.finInstDesc = undefined
        this.cargoForm.finInstDesc2 = undefined
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
      this.$router.push({ name: 'cargoQuoteClause' })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(QUOTE_CARGO_INSURED, this.cargoForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_CARGO_INSURED, this.cargoForm)
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 5)
          this.$router.push({ name: 'cargoQuotePremium' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doSendForRef() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_CARGO_INSURED, this.cargoForm)
          this.sendForRef()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async sendForRef() {
      const apiUrl = this.quotation.menu.refQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalCargoForm(this.$store.state.agency))

          // After success push to proposal page
          const dispatchObj = {
            proposalNo: result.data.proposalNo,
            query: true
          }
          await this.$store.dispatch('loadQuote', dispatchObj)
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been submitted for review')

          this.$router.push({ name: 'cargoQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          this.promptFieldCheck()
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 4) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
